import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import * as mainService from "@app/services/mainService";

const HeaderClick = (props) => {
    const [t] = useTranslation();
    let titleName = "Chỉnh sửa";
   // console.log('HeaderClick');
    //console.log(props);
    let detail = '';
    if (!props.isIndex) {
        if (props.isAddMode) {
            titleName = "Tạo mới";
        } else if (props.isDisplay) {
            titleName = "Xem";
        }
        detail = titleName;
    }

  /*  const [value, setValue] = useState({});
    useEffect(async () => {
        setValue( { currController: props.currController, headerName :props.headerName, detail : detail});
    }, []);

    useEffect(async () => {
        setValue( { currController: props.currController, headerName :props.headerName, detail : detail});
    }, []);*/

    const newItemButton = (
        <ol className="breadcrumb">
            <li className="breadcrumb-item">
                <Link to="/">{t('header.label.home')}</Link>
            </li>
            <li className="breadcrumb-item">
                <Link to={`/${props.currController}`}>{t(props.headerName)}</Link>
            </li>
            <li className="breadcrumb-item active">{detail !='' ? titleName : "" }</li>
            
        </ol>
    );
    // console.log('nameState', JSON.stringify(props, null, 2));
    return newItemButton;
};

export default HeaderClick;
